/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import ModerationRejectedNotificationDumb from './ModerationRejectedNotificationDumb';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: Notification<>,
};

const mapStateToProps = (): Object => ({});

const mapDispatchToProps = (
  dispatch: any,
  { notification }: Props,
): Object => ({
  handleDismiss() {
    dispatch(dismissNotification(notification));
  },
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ModerationRejectedNotificationDumb,
);
